import * as types from 'modules/payments/actionTypes';
import { createEntityAdapter, createReducer } from 'utils/ReduxUtils';

/** @typedef {import('utils/ReduxUtils').EntitySlice<PaymentDetails>} PaymentDataEntity */

/** @type {import('utils/ReduxUtils').EntityAdapter<PaymentDetails>} */
const paymentAdapter = createEntityAdapter({ selectId: ({ id }) => id });

/**
 * @param {PaymentDataEntity} state
 * @param {import('modules/global/generic.types').PageContent<PaymentDetails>} param1
 * @returns {PaymentDataEntity}
 */
const addManyFromPage = (state, { payload: { content } }) =>
  paymentAdapter.updateMany(state, content);

export default createReducer(paymentAdapter.getInitialState(), {
  [types.FETCH_PAYMENTS_SUCCESS]: addManyFromPage
});
